import {
  FETCH_GET_DOCUMENTS_BY_ID_REQUEST,
  FETCH_GET_DOCUMENTS_BY_ID_SUCCESS,
  FETCH_GET_DOCUMENTS_BY_ID_FALUIRE,
} from './getDocumentsByIDTypes'

const initialState = {
  loading: false,
  particularDocumentsInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_GET_DOCUMENTS_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_GET_DOCUMENTS_BY_ID_SUCCESS : return {
      ...state,
      particularDocumentsInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_GET_DOCUMENTS_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularDocumentsInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
